import { VALIDATION_STATUS } from "@/services/monday-service";

export const postFixValidationError = (postfix: string | undefined) => {
  const validationStatus = validateText(postfix);
  if (validationStatus === VALIDATION_STATUS.ERROR) {
    return { status: validationStatus, text: "Avoid any special characters." };
  }
  return { status: validationStatus, text: "" };
};

export const validateText = (value: string | undefined) => {
  const notAllowedChars = ["&", "<", ">", '"', "'"];
  if (value && notAllowedChars.some((ch) => value.includes(ch))) {
    return VALIDATION_STATUS.ERROR;
  }
  return VALIDATION_STATUS.SUCCESS;
};
